export const DEFAULT_DOCUMENTS_TITLE = 'Documents'

export const DEFAULT_PUBLISHER_BASE_URL = 'https://publisher.hitachienergy.com/documents'
